import axios from "axios";

class EmpreendimentosServiceGeo {
    baseUrlEmpreendimentos = "/empreendimentos/json";
    baseUrlEmpreendimento = "/empreendimento/json/";

    extractValuesArray = (array = []) => array.map(item => item.value);

    buildCommonFilters(state = {}) {
        const {
            bedrooms: quartos,
            status,
            incorporators: incorporadoras,
            property_of_interest: nome,
        } = state;

        return { quartos, status, incorporadoras, nome, };
    }

    async postEmpreendimentos(payload) {
        try {
            return await axios.post(this.baseUrlEmpreendimentos, payload);
        } catch (error) {
            console.error("Erro ao buscar empreendimentos", error);
            throw error;
        }
    }

    getEmpreendimentosWithinPolygon = async (path, state) => {
        const { tipo_empreendimento } = state;

        const requestBody = { tipo_empreendimento, polygon: path, ...this.buildCommonFilters(state), };

        return this.postEmpreendimentos(requestBody);
    };

    getEmpreendimentosWithinRadius = async (latitude, longitude, radius, state) => {
        const { padrao } = state;

        const requestBody = {
            padrao,
            circle: {
                latitude,
                longitude,
                radius,
            },
            ...this.buildCommonFilters(state),
        };

        return this.postEmpreendimentos(requestBody);
    };

    getEmpreendimento = async (id) => {
        try {
            const response = await axios.get(`${this.baseUrlEmpreendimento}${id}`);
            return response.data;
        } catch (error) {
            console.error("Erro ao buscar empreendimento", error);
            throw error;
        }
    };

    getEmpreendimentoOnCidade = async (state) => {
        const { tipo_empreendimento, city: cidade, } = state;

        const requestBody = { tipo_empreendimento, cidade, ...this.buildCommonFilters(state), };

        requestBody.cidade = requestBody.cidade.map((cidade) => cidade.label)

        return this.postEmpreendimentos(requestBody);
    };
}

export default new EmpreendimentosServiceGeo();
